<!--
 * @Descripttion: 
 * @version: 
 * @Author: wlk
 * @Date: 2023-12-19 20:25:01
 * @LastEditors: wlk
 * @LastEditTime: 2024-07-24 10:30:45
-->
<template>
  <ConfigProvider :locale="localeMap[locale].ant" :autoInsertSpaceInButton="false">
    <div class="content-wrap" v-wechat-title="$lang($route.meta.title)">
      <router-view />
    </div>
  </ConfigProvider>
</template>
<script lang="ts" setup>
  import { computed, onMounted, reactive, watch } from 'vue'
  import { ConfigProvider } from 'ant-design-vue'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import enUS from 'ant-design-vue/lib/locale-provider/en_US'
  import esEs from 'ant-design-vue/lib/locale-provider/es_ES'
  import { Locale } from 'ant-design-vue/lib/locale-provider'
  import dayjs from 'dayjs'
  import 'dayjs/locale/zh-cn.js'
  import 'dayjs/locale/es-mx.js'
  import 'dayjs/locale/en.js'
  import { useSettingStore, useAuthStore } from '@/store'
  import LangType from '@/utils/enums/LangType'
  import { useRouter } from 'vue-router'

  const router = useRouter()
  const authStore = useAuthStore()
  type Lang = keyof typeof LangType
  const sysSetting = useSettingStore()

  const localeMap = reactive<Record<Lang, { ant: Locale; dayjs: string }>>({
    zh: {
      ant: zhCN,
      dayjs: 'zh-ch'
    },
    es: {
      ant: esEs,
      dayjs: 'es-mx'
    },
    en: {
      ant: enUS,
      dayjs: 'en'
    }
  })

  const locale = computed(() => sysSetting.locale)
  dayjs.locale(localeMap[locale.value].dayjs)

  watch(
    () => locale.value,
    (c) => {
      dayjs.locale(localeMap[c].dayjs)
    }
  )

  onMounted(() => {
    let loading = document.getElementById('preloader')
    if (loading !== null) {
      document.body.removeChild(loading)
    }
  })
</script>
<style>
  #app {
    min-width: 1200px;
    width: 100%;
    font-family: PingFangSC, PingFangSC-Regular;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }

  .content-wrap {
    height: 100%;
  }

  .ant-table-cell:empty:after {
    content: '--';
  }
</style>
